import gql from 'graphql-tag';

const GET_DOCUMENT_UPLOAD_URL = gql`
  query getDocumentUploadUrl($documentType: String!) {
    documentUploadUrl(documentType: $documentType) {
      signedUploadUrl
      filePath
    }
  }
`;

export const getDocumentUploadUrl = client => documentType =>
  client.query({
    query: GET_DOCUMENT_UPLOAD_URL,
    fetchPolicy: 'network-only',
    variables: {
      documentType
    }
  });

export default { getDocumentUploadUrl };
